import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router-dom";

import styles from "./signin.module.scss";
import cx from "classnames";
import _ from "lodash";
import { Form, Button } from "react-bootstrap";
import AnonymousPageView from "pages/anonymous/common/AnonymousPageView.jsx";
import cleverStoryLogo from "../../../assets/images/logo/logo-cs.svg";

import {
  authenticateUser,
  authenticatingUserSucceeded,
  fetchSSOUrlFromEmail,
  ssoAuthenticationFailed,
  logoutUser,
  fetchUser,
  forgotPassword,
} from "actions/users";
import { createMixpanelEvent } from "actions/mixpanel";
import { MIXPANEL_USER_LOGIN } from "constants/mixpanelEvents";

export default function SigninView(props) {
  const { path } = useRouteMatch();

  return (
    <AnonymousPageView>
      <Switch>
        <Route path={`${path}`} exact>
          <SignInForm />
        </Route>
        <Route path={`${path}/forgot-password`} exact>
          <ForgotPasswordForm />
        </Route>
      </Switch>
    </AnonymousPageView>
  );
}

function SignInForm() {
  const history = useHistory();
  const dispatch = useDispatch();

  const passswordRef = React.createRef();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const ssoUrl = useSelector((state) => _.get(state, "users.sso.item.url"));
  const authenticated = useSelector((state) =>
    _.get(state, "users.authentication.authenticated")
  );
  const signinWithPassword = useSelector((state) =>
    _.get(state, "users.sso.signinWithPassword")
  );
  const authenticating = useSelector((state) =>
    _.get(state, "users.authentication.authenticating")
  );

  const authError = useSelector((state) =>
    _.get(state, "users.authentication.error")
  );

  var windowEventListener = null;

  useEffect(() => {
    dispatch(logoutUser());
  }, []);

  useEffect(() => {
    setError(authError);
  }, [authError]);

  useEffect(() => {
    if (ssoUrl && !authenticated) {
      initiateSSO(ssoUrl);
    }

    if (authenticated) {
      dispatch(fetchUser());
      history.push("/");
    }
  }, [ssoUrl, authenticated]);

  useEffect(() => {
    if (signinWithPassword) {
      passswordRef.current.focus();
    }
  }, [signinWithPassword]);

  const onLogin = (e) => {
    e.preventDefault();

    if (signinWithPassword) {
      dispatch(authenticateUser(username, password));
    } else {
      handleSSOClick(e);
    }
  };

  const handleSSOClick = (e) => {
    e.preventDefault();
    const validationError = validateUserName();

    if (validationError && validationError.trim().length !== 0) {
      setError(validationError);
      return;
    }

    dispatch(fetchSSOUrlFromEmail(username));
  };

  const validateUserName = () => {
    let error = null;
    var email = username;
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!email || email.trim() === "" || !regex.test(email)) {
      error = "Oopsie! Looks like  your email is invalid";
    }

    return error;
  };

  const handleUserName = (e) => {
    var value = e.target.value;
    if (value) {
      value = value.trim().toLowerCase();
    }

    setUsername(value);
    setError(null);
  };

  const handlePassword = (e) => {
    var value = e.target.value;
    if (value) {
      value = value.trim();
    }

    setPassword(value);
    setError(null);
  };

  const initiateSSO = (url) => {
    //Calculate Position
    var dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenLeft;
    var dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenTop;

    var width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : window.screen.width;
    var height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : window.screen.height;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    var windowName = "userConsole";
    var newWindow = window.open(
      url,
      windowName,
      `Initiating Single signon`,
      "scrollbars=yes, width=" +
      w +
      ", height=" +
      h +
      ", top=" +
      top +
      ", left=" +
      left
    );

    if (newWindow === null || typeof newWindow === "undefined") {
      // handlePopBlockedError(url);
    } else {
      newWindow.focus();
      windowEventListener = addEventListener(handleCodeRecievedEvent);
    }

    return false;
  };

  const addEventListener = (fn) => {
    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

    eventer(messageEvent, fn, false);

    return function () {
      var detachEventMethod = window.removeEventListener
        ? "removeEventListener"
        : "detachEvent";
      var deEventer = window[detachEventMethod];
      var messageEvent =
        detachEventMethod === "detachEvent" ? "onmessage" : "message";

      deEventer(messageEvent, fn, false);
    };
  };

  const handleCodeRecievedEvent = (e) => {
    if (e.data.type === "SSO_AUTHENTICATION_SUCCESS") {
      dispatch(authenticatingUserSucceeded(e.data.payload));

      dispatch(createMixpanelEvent(MIXPANEL_USER_LOGIN, {}))

      history.push("/");

      if (windowEventListener) {
        windowEventListener();
      }
    } else if (e.data.type === "SSO_AUTHENTICATION_FAILURE") {
      dispatch(ssoAuthenticationFailed(e.data.payload.reason));
      history.push("/sso/failure");

      if (windowEventListener) {
        windowEventListener();
      }
    }
  };

  const renderAuthenicateTitle = () => {
    if (authenticating === true) {
      return "Signing in...";
    } else {
      return "Sign In";
    }
  };

  return (
    <div className={cx(styles.form, styles.login)}>
      <img src={cleverStoryLogo} alt="Cleverstory logo" />

      <header className={styles.header}>Hello! Sign in to continue</header>

      <label className={styles.error}>{error}</label>

      <form onSubmit={onLogin} className={styles.loginForm}>
        <Form.Control
          className={styles.signinInput}
          type="text"
          value={username}
          onChange={handleUserName}
          placeholder="Email"
        />
        {signinWithPassword && (
          <>
            <Form.Control
              className={styles.signinInput}
              type="password"
              value={password}
              onChange={handlePassword}
              placeholder="Password"
              ref={passswordRef}
            />

            {!authenticating && (
              <div className={styles.forgotPasswordField}>
                <Link
                  to={"/login/forgot-password"}
                  className={styles.forgotPassword}
                >
                  Forgot password?
                </Link>
              </div>
            )}
          </>
        )}
        <Button className={styles.signinButton} type="submit" variant="primary">
          {renderAuthenicateTitle()}
        </Button>
      </form>
    </div>
  );
}

function ForgotPasswordForm() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [emailError,setEmailError] = useState("")
  const [postConfirm, setPostConfirm] = useState(false);

  const error = useSelector((state) =>
    _.get(state, "users.forgotPassword.error")
  );
  const processing = useSelector((state) =>
    _.get(state, "users.forgotPassword.loading")
  );

  const validateUserName = () => {

    let error = null
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!email || email.trim() === "" || !regex.test(email)) {
      error = "Enter a valid email address to reset password";
    }

    return error;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setEmailError("");
    const validationError = validateUserName();

    if (validationError && validationError.trim().length !== 0) {
      setEmailError(validationError)
      return;
    }
    dispatch(
      forgotPassword(email, () => {
        setPostConfirm(true);
      })
    );
  };

  return (
    <div className={cx(styles.form, styles.forgotPassword)}>
      <img src={cleverStoryLogo} alt="Cleverstory logo" />
      <header className={styles.header}>
        Forgot Password
      </header>

      <label className={styles.error}>{emailError || error}</label>

      {!postConfirm && (
        <form onSubmit={onSubmit} className={styles.forgotPasswordForm}>
          <Form.Control
            className={styles.signinInput}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />
          <div className={styles.signinField}>
            <Link to={"/login"} className={styles.signinLink}>
              Sign In
            </Link>
          </div>

          <Button
            type="submit"
            className={styles.signinButton}
            disabled={processing}
            variant="primary"
          >
            {processing ? "Processing..." : "Continue"}
          </Button>
        </form>
      )}

      {postConfirm && (
        <>
          <p>The link to change your password has been sent to your email</p>
          <Button as={Link} to="/login" className={styles.signinButton}>
            Dismiss
          </Button>
        </>
      )}
    </div>
  );
}
